// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"49349454","239":"2155cb15","422":"bd86d284","455":"70b04e7d"}[chunkId] + ".chunk.js";
};